var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Events",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Event-List-V3-Bulk-Create_CreateEvent",
    transform: "translate(-1339.000000, -142.000000)",
    fill: "#C9C9C9",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Close",
    transform: "translate(1347.500000, 149.500000) rotate(45.000000) translate(-1347.500000, -149.500000) translate(1337.000000, 139.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.6109127,9.97487373 L19.6109127,9.97487373 C20.1631975,9.97487373 20.6109127,10.422589 20.6109127,10.9748737 C20.6109127,11.5271585 20.1631975,11.9748737 19.6109127,11.9748737 L1.6109127,11.9748737 C1.05862795,11.9748737 0.610912703,11.5271585 0.610912703,10.9748737 C0.610912703,10.422589 1.05862795,9.97487373 1.6109127,9.97487373 Z",
    id: "Rectangle-9",
    transform: "translate(10.610913, 10.974874) rotate(90.000000) translate(-10.610913, -10.974874) "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-9",
    x: 0.5,
    y: 10.2071068,
    width: 20,
    height: 2,
    rx: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGrey);
export default __webpack_public_path__ + "static/media/Close_Grey.8ac7cddca04aad5236c7c897222a5ba2.svg";
export { ForwardRef as ReactComponent };